import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { getMapUrl, getParam, getURLSegment, closeDrawer, confirm, toHours } from '../../helpers/helpers.js';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';
import { formatPhoneNumber } from 'react-phone-number-input';
import { FeatureFlag } from "react-launch-darkly";

// Components
// import StepIn from '../VTC/StepIn';
import * as icons from '../Icons/Icons';
import VTCReview from '../VTC/Review';
import BVReview from './BVReview';
import ExamityReview from './ExamityReview';
import ProctorUReview from './ProctorUReview';
import AutomatedReview from './AutomatedReview';
import Incidents from '../Modules/Incidents';
import PermittedItems from '../Modules/PermittedItems';
import ExamMeta from '../Modules/ExamMeta';

const SessionDetail = observer(class SessionDetail extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.initPhoneRequest = this.initPhoneRequest.bind(this);
    this.settingsRedirect = this.settingsRedirect.bind(this);
    this.requestPhone = this.requestPhone.bind(this);
    this.renderWithProxyPhone = this.renderWithProxyPhone.bind(this);
    this.renderWithoutProxyPhone = this.renderWithoutProxyPhone.bind(this);
    this.showMeta = this.showMeta.bind(this);
  }

  componentWillMount() {
    // Get the exam sid from the URL
    let examSid = getURLSegment(this, 2);
    let sessionSid = this.props.routing.location.query.session;

    if(!examSid || examSid.substring(0, 2).toLowerCase() !== 'ex') {
      examSid = this.props.examSid;
    }

    if(!examSid) {
      examSid = this.props.routing.location.query.eventsFor;
    }

    if(!sessionSid || sessionSid.substring(0, 2).toLowerCase() !== 'es') {
      sessionSid = this.props.sessionSid;
    }

    if(!sessionSid) {
      closeDrawer(null, this.props.parent)
      this.props.routing.goBack();
      this.props.store.SessionStore.throwError(new Error("No active session found for enrollment"));
    }

    // Get currencies
    this.props.store.SessionStore.getCurrencies();

    // If exam session is closed, get incidents
    const _this = this;

    const callback = function(response) {
      _this.props.store.SessionStore.modalLoaded = true;

      if(response.data.status.toLowerCase() === 'closed' || response.data.status.toLowerCase() === 'cancelled') {
        _this.props.store.ExamStore.getSessionEvents(null, examSid, sessionSid, response.data);

        if (response.data.status.toLowerCase() === 'closed') {
          const urlData = {
            examSid,
            sessionSid
          };

          const payload = {
            reviewStatus: true
          };

          _this.props.store.ExamStore.updateReviewStatus(urlData, payload);
        }
      } else if(
        response.data.status.toLowerCase() === 'scheduled' &&
        response.data.schedulingModule === 'messaging'
      ) {
        const locations = [response.data.location.sid]

        _this.props.store.ProctorStore.getLocationDetails(locations);
      }
    }

    // Get exam session
    this.props.store.ExamStore.getExamSession(examSid, sessionSid, callback);

    // Get course data
    this.props.store.SessionStore.getCourseData(this.props.courseSid);

    // Get proxy phone numbers
    this.props.store.ExamStore.getCommProxy(examSid, sessionSid);

    // Store sids in state
    this.state = {
      examSid,
      sessionSid,
      showAllFiles: false
    }
  }

  componentWillUnmount() {
    this.props.store.ExamStore.resetSessionEvents();
  }

  initPhoneRequest() {
    const { translation } = this.props;
    const { mobilePhone } = this.props.store.SessionStore.profile;

    // Check user’s profile for mobile phone number
    if(!mobilePhone) {
      // If user doesn’t have a mobile phone number,
      // tell them they need one and then send them
      // to their settings page
      confirm(translation.phone_dialog_unavailable, this.settingsRedirect);
    } else {
      // Otherwise, send the API request
      confirm(translation.phone_dialog, this.requestPhone);
    }
  }

  settingsRedirect() {
    const _this = this;
    const callback = function(){
      _this.props.routing.push({
        pathname: '/settings',
      });
    }

    closeDrawer(null, this.props.parent, null, callback);
  }

  requestPhone() {
    this.props.store.ExamStore.createCommProxy(this.state.examSid, this.state.sessionSid);
  }

  showMeta() {
    const { SessionStore } = this.props.store;

    let examSid = this.props.examSid;
    let sessionSid = this.props.sessionSid;

    if(!examSid) {
      examSid = getURLSegment(this, 2);
    }

    if(!examSid) {
      examSid = getParam('eventsFor', window.location.href);
    }

    if(!sessionSid) {
      sessionSid = this.props.routing.location.query.session;
    }

    const content = <ExamMeta
                      {...this.props}
                      examSid={examSid}
                      sessionSid={sessionSid}
                    />;

    SessionStore.showModal = true;
    SessionStore.modalSmall = true;
    SessionStore.modalContent = content;
  }

  // Proxy phone feature flag enabled
  renderWithProxyPhone() {
    const { translation } = this.props;
    const { proxyNumbers } = this.props.store.ExamStore;
    let session = this.props.store.ExamStore.examSession;
    let { location, proctor } = session;
    const { SessionStore } = this.props.store;

    let name = '';

    if(location && location.accountName) {
      name = location.accountName;
    } else if (proctor && proctor.firstName) {
      name = proctor.firstName;
    }

    return (
      <ul className="data--alt">
        {
          session.schedulingModule !== 'proctoru' &&
          session.schedulingModule !== 'examity' &&

          <li>
            <strong className="subtitle">{translation.proctor_information.name}</strong>
            <p>
              {name} &nbsp;

              {
                session.schedulingModule === 'register-blast' &&
                SessionStore.userData.role.toLowerCase() !== 'learner' &&

                <button
                  onClick={this.showMeta}
                  className="btn--link"
                >
                  {translation.meta}
                </button>
              }
            </p>
          </li>
        }

        {
          session.schedulingModule === 'proctoru' &&
          SessionStore.userData.role.toLowerCase() !== 'learner' &&

          <li>
            <strong className="subtitle">{translation.proctor_information.platform}</strong>
            <p>
              ProctorU &nbsp;

              <button
                onClick={this.showMeta}
                className="btn--link"
              >
                {translation.meta}
              </button>
            </p>
          </li>
        }

        {
          session.schedulingModule === 'examity' &&
          SessionStore.userData.role.toLowerCase() !== 'learner' &&

          <li>
            <strong className="subtitle">{translation.proctor_information.platform}</strong>
            <p>
              Examity &nbsp;

              <button
                onClick={this.showMeta}
                className="btn--link"
              >
                {translation.meta}
              </button>
            </p>
          </li>
        }

        {/* Messaging session with no proxy number created */}
        {
          session.schedulingModule === 'messaging' &&
          !proxyNumbers.proxyProctorProxyPhoneNumber &&
          session.status.toLowerCase() !== 'closed' &&
          <li>
            <strong className="subtitle">{translation.proctor_information.phone}</strong>
            <button
              className="btn--link"
              onClick={this.initPhoneRequest}
            >
              {translation.proctor_information.request_phone}
            </button>
          </li>
        }

        {/* Messaging session with proxy number */}
        {
          session.schedulingModule === 'messaging' &&
          proxyNumbers.proxyProctorProxyPhoneNumber &&
          session.status.toLowerCase() !== 'closed' &&
          <li>
            <strong className="subtitle">{translation.proctor_information.phone}</strong>
            <p>{formatPhoneNumber(proxyNumbers.proxyProctorProxyPhoneNumber, 'National')}</p>
          </li>
        }
      </ul>
    )
  }

  // Proxy phone feature flag disabled
  renderWithoutProxyPhone() {
    const { translation } = this.props;
    let session = this.props.store.ExamStore.examSession;
    let { location, proctor } = session;
    const { SessionStore } = this.props.store;

    let name = '';

    if(location && location.accountName) {
      name = location.accountName;
    } else if (proctor && proctor.firstName) {
      name = proctor.firstName;
    }

    return (
      <ul className="data--alt">
        {
          session.schedulingModule !== 'proctoru' &&
          session.schedulingModule !== 'examity' &&
          <li>
            <strong className="subtitle">{translation.proctor_information.name}</strong>
            <p>
              {name} &nbsp;

              {
                session.schedulingModule === 'register-blast' &&
                SessionStore.userData.role.toLowerCase() !== 'learner' &&

                <button
                  onClick={this.showMeta}
                  className="btn--link"
                >
                  {translation.meta}
                </button>
              }
            </p>
          </li>
        }

        {
          session.schedulingModule === 'proctoru' &&
          SessionStore.userData.role.toLowerCase() !== 'learner' &&

          <li>
            <strong className="subtitle">{translation.proctor_information.platform}</strong>
            <p>
              ProctorU &nbsp;

              <button
                onClick={this.showMeta}
                className="btn--link"
              >
                {translation.meta}
              </button>
            </p>
          </li>
        }

        {
          session.schedulingModule === 'examity' &&
          SessionStore.userData.role.toLowerCase() !== 'learner' &&

          <li>
            <strong className="subtitle">{translation.proctor_information.platform}</strong>
            <p>
              Examity &nbsp;

              <button
                onClick={this.showMeta}
                className="btn--link"
              >
                {translation.meta}
              </button>
            </p>
          </li>
        }
      </ul>
    )
  }

  render() {
    const { exam, translation, } = this.props;
    let { workflowModule } = this.props;
    const { SessionStore, ProctorStore } = this.props.store;
    let session = this.props.store.ExamStore.examSession;
    let { location } = session;

    // if we do not pass in the workflowModule from props, we need to get it from the location
    if (!workflowModule) {
      workflowModule = location.workflowModule;
    }

    let latitude = null;
    let longitude = null;

    if(location) {
      latitude = location.latitude;
      longitude = location.longitude;
    }

    let address = (location) ? `${location.address1 || ''} ${location.address2 || ''}` : '';

    const { instructor } = this.props.store.SessionStore.courseData;
    const { sessionEvents } = this.props.store.ExamStore;
    const { userTimezone } = this.props.store.SessionStore;
    const { examConfiguration } = session;

    // Check if browser supports VTC live-view
    let stepInSupported = true;

    if(document.querySelector('html').className.indexOf('ie-true') > -1) {
      stepInSupported = false;
    }

    if(
      !SessionStore.loading ||
      (
        SessionStore.loading && SessionStore.loadingCalls.length === 1 && SessionStore.loadingCalls.indexOf('BVData') >= 0
      ) || (
        SessionStore.loading && SessionStore.loadingCalls.length === 1 && SessionStore.loadingCalls.indexOf('getSessionMeta') >= 0
      )
    ) {
      return (
        <div className="drawer__content">
          {!this.props.modal &&
            <header className="drawer__header">
              <div className="wrap">
                <h1 className="drawer__title">{translation.heading}</h1>
              </div>
            </header>
          }

          <div className="wrap session-detail">
            {/* If this is a VTC session and the status is not closed, show the StepIn component */}
            {/* {
              session.schedulingModule === 'vtc' &&
              session.status.toLowerCase() !== 'closed' &&
              stepInSupported &&
              <StepIn {...this.props} sessionDetail={true} accessCode={session.accessKey} />
            } */}

            {
              session.schedulingModule === 'vtc' &&
              session.status.toLowerCase() !== 'closed' &&
              !stepInSupported &&
              <div className="cta">
                <strong className="cta__copy">{translation.not_supported.heading}</strong>
                <span className="cta_subcopy">{translation.not_supported.body}</span>
              </div>
            }

            {/* If this is a VTC session and the status is closed, show the VTC Reviewer */}
            {
              session.schedulingModule === 'vtc' &&
              session.status.toLowerCase() === 'closed' &&
              <VTCReview
                {...this.props}
                accessCode={session.accessKey}
              />
            }

            {/* If this is a written exam, show the uploaded exam file */}
            {
              exam &&
              exam.type.toLowerCase() === 'written' &&
              session.status.toLowerCase() === 'closed' &&
              session.returnedFile &&
              <div className="panel__files">
                <section className="panel__section">
                  <h2 className="panel__heading">
                    {translation.returned_files.heading}
                  </h2>

                  <ul className="files">
                    <li>
                      <a
                        className="files__title"
                        href={session.returnedFile.file}
                        target="_blank"
                      >
                        <icons.icon_pdf />
                        {moment.utc(session.returnedFile.createdDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}
                      </a>
                    </li>
                  </ul>

                  {
                    session.returnedFile.otherFiles &&
                    session.returnedFile.otherFiles.length > 0 &&

                    <span className="panel__expand">
                      <button
                        className={`
                          btn--expand
                          ${this.state.showAllFiles ? 'expanded' : ''}
                        `}
                        onClick={() => this.setState({showAllFiles: !this.state.showAllFiles})}
                      >
                        <span className="meta">
                          {!this.state.showAllFiles &&
                            translation.returned_files.more
                          }

                          {this.state.showAllFiles &&
                            translation.returned_files.less
                          }
                        </span>
                      </button>

                      {!this.state.showAllFiles &&
                        translation.returned_files.more
                      }

                      {this.state.showAllFiles &&
                        translation.returned_files.less
                      }
                    </span>
                  }

                  {this.state.showAllFiles &&
                    <ul className="files">
                      {session.returnedFile.otherFiles.map(
                        (file, i) =>
                        <li>
                          <a
                            className="files__title"
                            href={file.file}
                            target="_blank"
                          >
                            <icons.icon_pdf />
                            {moment.utc(file.createdDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}
                          </a>
                        </li>
                      )}
                    </ul>
                  }
                </section>
              </div>
            }

            {/* Show the session details (lots of conditionals here based on session type) */}
            {session.schedulingModule !== 'automated' && workflowModule !== 'hybrid-scheduling' &&
              <section
                className={`panel__section ${session.schedulingModule !== 'vtc' ? 'panel__section--half' : ''}`}
              >
                <h2 className="panel__heading">{translation.general_information.heading}</h2>

                <ul className="data--alt">
                  <li>
                    <strong className="subtitle">{translation.general_information.status}</strong>
                    <p>{session.status}</p>
                  </li>
                  <li>
                    <strong className="subtitle">{translation.general_information.exam_type}</strong>

                    {exam.type &&
                      <p className="capitalize">{exam.type === ("Online" || "Live Online") ? translation.general_information.online_exam : exam.type}</p>
                    }

                    {session.schedulingModule === 'vtc' &&
                      <p className="capitalize">Virtual Testing Center</p>
                    }

                  </li>
                  {session.schedulingModule !== 'vtc' &&
                    <li>
                      <strong className="subtitle">{translation.general_information.appointment_date}</strong>
                      <p>{moment.utc(session.appointmentDate).tz(userTimezone).format('M/D/YYYY [at] h:mma z')}</p>
                    </li>
                  }

                  <li>
                    <strong
                      className="subtitle"
                    >
                      {translation.general_information.duration}
                    </strong>

                    <p>{toHours(examConfiguration.duration, false, false, true)}</p>
                  </li>

                  <PermittedItems
                    configuration={examConfiguration}
                    listItem={true}
                    {...this.props}
                  />
                </ul>
              </section>
            }

            {/* Proctor details */}
            {
              session.schedulingModule !== 'vtc' &&
              session.schedulingModule !== 'automated' &&
              workflowModule !== 'hybrid-scheduling' &&

              <section className="panel__section panel__section--half">
                <h2 className="panel__heading">{translation.proctor_information.heading}</h2>

                {session.schedulingModule !== 'instructor-as-proctor' &&
                  <FeatureFlag
                    flagKey="proxy-phone-number"
                    renderFeatureCallback={this.renderWithProxyPhone}
                    renderDefaultCallback={this.renderWithoutProxyPhone}
                  />
                }

                {session.schedulingModule === 'instructor-as-proctor' && typeof instructor !== 'undefined' &&
                  <ul className="data--alt">
                    <li>
                      <strong className="subtitle">{translation.proctor_information.name}</strong>
                      <p>{instructor.firstName} {instructor.lastName} ({translation.instructor})</p>
                    </li>
                    <li>
                      <strong className="subtitle">{translation.proctor_information.email}</strong>
                      <p>{instructor.email}</p>
                    </li>
                  </ul>
                }
              </section>
            }

            {/* If this is a remote session and the status is closed, cancelled, or in progress, show the reviewer*/}
            {
              (session.schedulingModule === 'automated' || workflowModule === 'hybrid-scheduling' || workflowModule === 'hybrid') &&
              (session.status.toLowerCase() === 'closed' 
              || session.status.toLowerCase() === 'cancelled' 
              || session.status.toLowerCase() === 'in progress'
              || session.status.toLowerCase() === 'onboarding'
              || session.status.toLowerCase() === 'disconnected') &&
              <AutomatedReview
                {...this.props}
                examSid={this.state.examSid}
                sessionSid={this.state.sessionSid}
              />
            }

            {/* If this is an Examity session and the status is closed, show the video */}
            {
              session.schedulingModule === 'examity' &&
              (session.status.toLowerCase() === 'closed') &&
              <ExamityReview
                {...this.props}
                sessionSid={this.state.sessionSid}
                examSid={this.state.examSid}
              />
            }

            {/* If this is an ProctorU session and the status is closed, show the video */}
            {
              session.schedulingModule === 'proctoru' &&
              (session.status.toLowerCase() === 'closed') &&
              <ProctorUReview
                {...this.props}
                sessionSid={this.state.sessionSid}
                examSid={this.state.examSid}
              />
            }

            {/* If this is a BV session and the status is closed, show the BV reviewer */}
            {
              session.schedulingModule === 'b-virtual' &&
              (session.status.toLowerCase() === 'closed' ||
              session.status.toLowerCase() === 'cancelled') &&
              <BVReview
                {...this.props}
                sessionSid={this.state.sessionSid}
                examSid={this.state.examSid}
              />
            }

            {/* Incident details */}
            {
              sessionEvents.length > 0 &&
              SessionStore.userData.role.toLowerCase() !== 'learner' &&
              session.schedulingModule !== 'vtc' &&
              !this.props.hideIncidents &&
              <Incidents
                events={sessionEvents}
                session={session}
                embedded={true}
                {...this.props}
              />
            }

            {/* Location details */}
            {
              session.schedulingModule !== 'automated' &&
              session.schedulingModule !== 'vtc' &&
              session.schedulingModule !== 'examity' &&
              session.schedulingModule !== 'proctoru' &&
              workflowModule !== 'hybrid-scheduling' &&

              <section className="panel__section session-detail__location">
                {session.schedulingModule !== 'b-virtual' &&
                  <h2 className="panel__heading">{translation.location_information.heading}</h2>
                }

                {
                  session.schedulingModule !== 'instructor-as-proctor' &&
                  session.schedulingModule !== 'b-virtual' &&
                  <img
                    className="map--static session-detail__map"
                    width="400" height="250"
                    src={getMapUrl(latitude, longitude)}
                    alt="A map of the location" />
                }

                {
                  session.schedulingModule !== 'instructor-as-proctor' &&
                  session.schedulingModule !== 'b-virtual' &&
                  location &&
                  <ul className="data--alt vcard">
                    <li>
                      <strong className="subtitle">{translation.location_information.address}</strong>
                      <p className="adr">
                        {
                          ProctorStore.proctorLocation &&
                          ProctorStore.proctorLocation.location &&
                          <span>{ProctorStore.proctorLocation.location.name}</span>
                        }
                        <span className="street-address">{address}</span>
                        <span className="locality">{location.place}</span>
                        <span className="region">{location.region ? `, ${location.region}` : '' }</span>
                        <span className="postal-code">{location.postalCode}</span>
                        <span className="country">{location.country}</span>
                      </p>
                    </li>
                    {
                      ProctorStore.proctorLocation &&
                      ProctorStore.proctorLocation.location &&
                      ProctorStore.proctorLocation.location.parkingInformation &&

                      <li>
                        <strong className="subtitle">
                          {translation.location_information.parking}
                        </strong>

                        <p>
                          {ProctorStore.proctorLocation.location.parkingInformation}
                        </p>
                      </li>
                    }
                  </ul>
                }

                {session.schedulingModule === 'instructor-as-proctor' &&
                  <ul className="data--alt vcard">
                    <li>
                      <strong className="subtitle">{translation.location_information.address}</strong>
                      <p className="adr">{session.location.address1}</p>
                    </li>
                  </ul>
                }
              </section>
            }
          </div>
        </div>
      )
    }

    return null;
  }
})

export default translate('SessionDetail')(SessionDetail);



// WEBPACK FOOTER //
// ./src/app/components/Sessions/SessionDetail.js